import { render, staticRenderFns } from "./TeamComposition.vue?vue&type=template&id=07151f8e&scoped=true"
import script from "./TeamComposition.vue?vue&type=script&lang=js"
export * from "./TeamComposition.vue?vue&type=script&lang=js"
import style0 from "./TeamComposition.vue?vue&type=style&index=0&id=07151f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07151f8e",
  null
  
)

export default component.exports